// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__knKIX","loaderOuter":"PageOverlayLoader_loaderOuter__k3vo6"};